import React from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Wagmi configuration
import { WagmiProvider } from 'wagmi'

// Pages
import LoginPage from './pages/LoginPage'
import DataPage from './pages/DataPage'
import DataDetailPage from './pages/DataDetailPage'
import ProfilePage from './pages/ProfilePage'
import DataUploadPage from './pages/DataUploadPage'

// Components
import Layout from './components/Layout'
import AdminRoute from './components/AdminRoute'

// Theme
import theme from './theme'

// wagmi config
import { config } from './wagmiConfig'
import DataWhitelistPage from './pages/DataWhitelistPage'

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const App: React.FC = () => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected routes - wrapped in Layout component */}
              <Route
                path="/"
                element={
                  <Layout>
                    <Navigate to="/record/data" replace />
                  </Layout>
                }
              />
              <Route
                path="/record/:type"
                element={
                  <Layout>
                    <DataPage />
                  </Layout>
                }
              />
              <Route
                path="/record/data/:id"
                element={
                  <Layout>
                    <DataDetailPage />
                  </Layout>
                }
              />
              <Route
                path="/record/data/create"
                element={
                  <Layout>
                    <DataUploadPage />
                  </Layout>
                }
              />
              <Route
                path="/profile"
                element={
                  <Layout>
                    <ProfilePage />
                  </Layout>
                }
              />
              <Route
                path="/whitelist"
                element={
                  <Layout>
                    <AdminRoute>
                      <DataWhitelistPage />
                    </AdminRoute>
                  </Layout>
                }
              />

              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </ChakraProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default App
